export default "__VITE_ASSET__Cvhn9XZa__"